import React from 'react'
import "./Explore_game_tab_section.css"
import How_To_Play_Game_tab_content from './how_To_Play_Game_tab_content/How_To_Play_Game_tab_content'
import { Tab, Tabs } from 'react-bootstrap'
import History_tab_content from './history_tab_content/History_tab_content'

function Explore_game_tab_section() {
    return (
        <>
            <section className='Explore_game_tab_section section_margin'>
                <div className="container">
                    <Tabs
                        defaultActiveKey="How_To_Play_Game"
                        id="justify-tab-example"
                        className="mb-3"
                        justify
                    >
                        <Tab eventKey="How_To_Play_Game" title="How_To_Play_Game">
                            <How_To_Play_Game_tab_content />
                        </Tab>
                        <Tab eventKey="History" title="History">
                            <History_tab_content />
                        </Tab>
                    </Tabs>
                </div>
            </section>
        </>
    )
}

export default Explore_game_tab_section